import 'url-search-params-polyfill';
import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useAuthorizationStatus } from '@mos-utils/acs-react';

import Cancel from '../../components/Cancel/Cancel';
import { successServiceNumberSelector } from '../../store/requestDataSuccess/selectors';
import { goToHomePage } from '../../store/step/actions';
import acs from '@mos-utils/acs';
import Spinner from '../../components/Spinner/Spinner';
import Modal from '@mos-cat/modal';
import Content from '../../components/Content/Content';
import Button from '../../components/Button/Button';
import { basename } from '../../AppHistory';

import BreadcrumbsContext from '../../components/BreadcrumbsContext';

function getBackUrl() {
  if (window.location.href.includes('cancel')) {
    return window.location.href;
  }
  return window.location.href + 'cancel/';
}

const decodeServiceNumber = (serviceNumber, pathname) => {
  if (serviceNumber.includes('%2F')) {
    return serviceNumber.replace('%2F', '/');
  }

  const trimmedPathname = pathname
    .replace('/cancel/', '')
    .replace('success-cancel/', '');

  return trimmedPathname.endsWith('/')
    ? trimmedPathname.slice(0, trimmedPathname.length - 1)
    : trimmedPathname;
};

function getType(serviceNumber) {
  const match = (serviceNumber || '').match(/\d+-\d+-(\d+)-\d+/);
  if (!match || match.length < 2) {
    return null;
  }
  const code = match[1];
  switch (code) {
    case '040203':
      return 'inconsistencyOfBlanks';
    case '040202':
      return 'disagreementOfResults';
    default:
      return null;
  }
}

const CancelPage = ({ goToHomePage, match, location }) => {
  useEffect(() => window.scrollTo(0, 0), []);

  const authorizationStatus = useAuthorizationStatus();
  const { endCrumbs, setEndCrumbs } = useContext(BreadcrumbsContext);

  const { params: { serviceNumber = '' } = {} } = match;
  const { pathname = '' } = location;
  const fullPathname = `${basename}${pathname}`;

  if (!serviceNumber) {
    goToHomePage();
  }

  const type = getType(serviceNumber);

  useEffect(() => {
    if (type === 'inconsistencyOfBlanks') {
      setEndCrumbs([
        {
          url: fullPathname,
          name: 'Отзыв заявления о несоответствии бланков',
          notForHome: true
        },
        {
          url: fullPathname,
          name: 'Отзыв заявления о несоответствии бланков',
          forMobile: true
        }
      ]);
    } else {
      setEndCrumbs([
        {
          url: fullPathname,
          name: 'Отзыв апелляции о несогласии с выставленными баллами ГИА',
          notForHome: true
        },
        {
          url: fullPathname,
          name: 'Отзыв апелляции о несогласии c баллами',
          forMobile: true
        }
      ]);
    }

    return () => {
      setEndCrumbs([]);
    };
  }, [endCrumbs.length]);

  useEffect(() => {
    if (authorizationStatus === 'unauthorized') {
      const url = getBackUrl();
      acs.login(url);
    }
  }, [authorizationStatus]);

  if (authorizationStatus === 'authorized') {
    return (
      <div className="CancelPage">
        <Cancel
          serviceNumber={decodeServiceNumber(serviceNumber, pathname)}
          type={type}
        />
      </div>
    );
  }

  return (
    <div className="FormPage">
      {authorizationStatus === 'unknown' && <Spinner middle />}

      <Modal visible={authorizationStatus === 'error'} onCancel={() => {}}>
        <div className="ModalError" />
        <Content>
          <Content.Title>Произошла ошибка авторизации</Content.Title>
          <Content.Text>
            Попробуйте заново войти в личный кабинет и продолжить
          </Content.Text>
          <Content.Button>
            <Button
              primary
              onClick={() => {
                acs.login(window.location.href);
              }}
            >
              Войти
            </Button>
          </Content.Button>
        </Content>
      </Modal>
    </div>
  );
};

CancelPage.defaultProps = {
  serviceNumber: null
};

CancelPage.propTypes = {
  goToHomePage: PropTypes.func.isRequired,
  serviceNumber: PropTypes.string
};

const mapStateToProps = state => ({
  serviceNumber: successServiceNumberSelector(state)
});

export default connect(mapStateToProps, dispatch =>
  bindActionCreators(
    {
      goToHomePage
    },
    dispatch
  )
)(CancelPage);
